import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M92.309-288.462l149.23-383.076h63.691l148.461 383.076h-63.537l-34.769-95.231h-164.77l-35.077 95.231h-63.23zM209.23-435.538h125.54l-59.539-166.924H270l-60.77 166.924zm347.232 147.076v-56.768l205.077-272.001H564.462v-54.307h265.076v56.768L625.691-342.769h205.847v54.307H556.462zM369.231-763.846L480-874.615l110.769 110.769H369.231zM480-85.385L369.231-196.154h221.538L480-85.385z"></path>
    </svg>;
}
export default Icon;